import logo from 'assets/images/logo.svg';

export const WorkoutPlayerHeader = {
  bindings: {
    isComplete: '<',
    isFinished: '<',
    onClickFinish: '&',
    onClickLogo: '&',
  },

  template: `
    <div class="workout-player-header mx-2 mx-sm-0"
      ng-class="{ 'workout-player-header-complete': $ctrl.isComplete }">
      <div class="row align-items-center justify-content-between">
        <div class="col-5">
          <button-back>
            Workout<span class="d-none d-md-inline"> Overview</span>
          </button-back>
        </div>
        <div class="col-2 text-center">
          <button-link ng-click="$ctrl.onClickLogo()">
            <nav-logo></nav-logo>
          </button-link>
        </div>
        <div class="col-5 text-right">
          <div class="pr-2 pr-md-0">
            <workout-player-finish-modal
              is-finished="$ctrl.isFinished"
              on-finish="$ctrl.onClickFinish()">
            </workout-player-finish-modal>
          </div>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerHeader.js